/* eslint-disable no-template-curly-in-string */
import R from 'ramda'

const ADD_TIMED_THREAD_DISPLAY_TYPE = 'Add Timed Thread Activity'
const ADD_TIMED_THREAD_WIDGET_TYPE = 'ADD_TIMED_THREAD_ACTIVITY'

const isTimedThreadDisplayType = R.propEq('type', ADD_TIMED_THREAD_DISPLAY_TYPE)

const convertAddFormToWidget = R.applySpec({
  type: R.always(ADD_TIMED_THREAD_WIDGET_TYPE),
  userId: R.always('${senderId}'),
  tweetId: R.always('${tweetId}'),
  timestamp: R.always('${createdTimestamp}'),
  userHandle: R.always('${senderHandle}')
})

export { isTimedThreadDisplayType, convertAddFormToWidget }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/form-to-widget/add-timed-thread-activity.js